module.exports = __webpack_public_path__ + "img/13.1851ff11.jpg";